import { Link } from "react-router-dom";

export function BrandLogo({ testId = "header-logo-link" }: { testId?: string }) {
  return (
    <Link to="/" className="group flex items-center gap-2.5" data-testid={testId} aria-label="Wellness Radiance Nutrition home">
      <img
        src="/logo-mark-light.png"
        alt="Wellness Radiance Nutrition logo"
        width={260}
        height={144}
        className="h-9 w-auto transition-transform duration-700 ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-105 sm:h-11"
        data-testid={`${testId}-image`}
      />
      <span className="leading-none">
        <span className="block font-display text-[1.2rem] sm:text-[1.42rem]">
          <span className="text-cream">Wellness</span> <span className="text-gold-soft">Radiance</span>
        </span>
        <span className="mt-1 block text-[0.6rem] font-bold uppercase tracking-[0.42em] text-cream/80">Nutrition</span>
      </span>
    </Link>
  );
}

export function LogoCard() {
  return (
    <Link to="/" aria-label="Wellness Radiance Nutrition home" data-testid="footer-logo-link" className="inline-block rounded-[24px] bg-cream p-5">
      <img src="/logo.png" alt="Wellness Radiance Nutrition — Nourish · Energise · Transform" width={900} height={472} loading="lazy" className="h-auto w-52 sm:w-60" data-testid="footer-logo-image" />
    </Link>
  );
}
